// import React, { useState, useEffect } from "react";
// import DataTable from "react-data-table-component";
// import FilterModal from "../Filter Modal/FilterModal";

// export default function DataTable_Component({ apidata, columns, searchBy }) {
//   const [dataFilter, setDataFilter] = useState("");

//   const [filteredData, setFilteredData] = useState([]);
//   const [showFilterModal, setShowFilterModal] = useState(false);

//   useEffect(() => {
//     let filtered = apidata;

//     if (dataFilter) {
//       filtered = filtered.filter((item) => {
//         // Flexible search logic for different fields
//         if (searchBy === "titlr") {
//           return item.title.toLowerCase().startsWith(dataFilter.toLowerCase());
//         }
//         // Add more conditions as needed for other fields
//         return false;
//       });
//     }

//     setFilteredData(filtered);
//   }, [dataFilter, apidata, searchBy]);

//   const applyFilters = () => {
//     setShowFilterModal(false);
//   };

//   const removeFilters = () => {
//     setShowFilterModal(false);
//   };

//   return (
//     <div className="table-responsive">
//       <div className="row justify-content-between mb-2">
//         <div className="col-md-3 mb-2">
//           <input
//             type="text"
//             placeholder={`Search by ${searchBy}`}
//             className="form-control"
//             value={dataFilter}
//             onChange={(e) => setDataFilter(e.target.value)}
//           />
//         </div>
//         <div className="col-md-9 mb-2">
//           {/* <button
//             className="btn btn-primary"
//             onClick={() => setShowFilterModal(true)}
//           >
//             Filter
//           </button> */}
//         </div>
//       </div>
//       {filteredData.length > 0 ? (
//         <DataTable
//           columns={columns}
//           data={filteredData}
//           pagination
//           fixedHeader
//           highlightOnHover
//           responsive
//           paginationPerPage={5}
//           paginationRowsPerPageOptions={[5, 10, 15, 20]}
//         />
//       ) : (
//         <div className="row justify-content-start">
//           <div className="col-12">
//             <p>No results found.</p>
//           </div>
//         </div>
//       )}
//       <FilterModal
//         show={showFilterModal}
//         onHide={() => setShowFilterModal(false)}
//         applyFilters={applyFilters}
//         removeFilters={removeFilters}
//         apidata={apidata}
//       />
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({ apidata, columns, searchBy }) {
  const [dataFilter, setDataFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filters, setFilters] = useState({ status: "", city: "", date: "" });

  // Apply search + filters
  useEffect(() => {
    let filtered = apidata;

    // Search filter (by title)
    if (dataFilter) {
      filtered = filtered.filter((item) =>
        item.title.toLowerCase().includes(dataFilter.toLowerCase())
      );
    }

    // Status filter
    if (filters.status) {
      filtered = filtered.filter((item) => item.status === filters.status);
    }

    // City filter
    if (filters.city) {
      filtered = filtered.filter((item) => item.city === filters.city);
    }

    // Date filter (compare only yyyy-mm-dd)
    if (filters.date) {
      filtered = filtered.filter((item) => {
        const jobDate = new Date(item.date).toISOString().split("T")[0];
        return jobDate === filters.date;
      });
    }

    setFilteredData(filtered);
  }, [dataFilter, apidata, searchBy, filters]);

  const applyFilters = (filterValues) => {
    setFilters(filterValues);
  };

  const removeFilters = () => {
    setFilters({ status: "", city: "", date: "" });
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
        />
      ) : (
        <div className="row justify-content-start">
          <div className="col-12">
            <p>No results found.</p>
          </div>
        </div>
      )}

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        apidata={apidata}
      />
    </div>
  );
}
